import { useState } from "react";

interface EpisodeListProps {
  episodeTitles: string[];
  currentEpisode: number;
  onPlay: (index: number) => void;
}

const PAGE_SIZE = 12;

export default function EpisodeList({ episodeTitles, currentEpisode, onPlay }: EpisodeListProps) {
  const [page, setPage] = useState(1);
  const totalPages = Math.max(1, Math.ceil(episodeTitles.length / PAGE_SIZE));
  const current = Math.min(page, totalPages);
  const items = episodeTitles.slice((current - 1) * PAGE_SIZE, current * PAGE_SIZE);

  return (
    <div>
      <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 gap-2.5">
        {items.map((title, i) => {
          const index = (current - 1) * PAGE_SIZE + i;
          const isActive = index === currentEpisode;
          return (
            <button
              key={title}
              onClick={() => onPlay(index)}
              className={`flex items-center gap-2 px-3 py-2.5 rounded-md border text-left text-sm transition-colors cursor-pointer ${
                isActive
                  ? "border-primary-400 bg-primary-50 text-primary-700"
                  : "border-background-200 text-foreground-700 hover:border-primary-300 hover:bg-background-100"
              }`}
            >
              <i className={`${isActive ? "ri-play-circle-fill text-primary-500" : "ri-play-circle-line text-foreground-400"} text-lg shrink-0`} />
              <span className="truncate">{title}</span>
            </button>
          );
        })}
      </div>

      {totalPages > 1 && (
        <div className="flex items-center justify-center gap-2 mt-6">
          <button
            onClick={() => setPage(Math.max(1, current - 1))}
            disabled={current === 1}
            className="h-9 px-3 rounded-md border border-background-200 text-sm text-foreground-600 hover:border-primary-300 disabled:opacity-40 disabled:cursor-not-allowed cursor-pointer whitespace-nowrap"
          >
            上一页
          </button>
          <span className="text-sm text-foreground-500 px-2">
            第 {current} / {totalPages} 页
          </span>
          <button
            onClick={() => setPage(Math.min(totalPages, current + 1))}
            disabled={current === totalPages}
            className="h-9 px-3 rounded-md border border-background-200 text-sm text-foreground-600 hover:border-primary-300 disabled:opacity-40 disabled:cursor-not-allowed cursor-pointer whitespace-nowrap"
          >
            下一页
          </button>
        </div>
      )}
    </div>
  );
}